import $ = require("jquery");
import _ = require("underscore");
import ol = require("ol");
import MapView = require("../views/MapView");
import Utils = require("../utils");
import geo = require("../utils/geo");
import Portal = require("portal-gis");
import Mediator = require("../mediator");
import Templates = require("../models/defaults");
import BaseHelper = require("./base/group-helper");

class Helper extends BaseHelper {

    create() {
        _.defaults(this.options, { layerType: "wms" });
        return super.create();
    }

    // tilewmssource has no provision for testing if layer is outside extent
    // apart from zooming too close but getcaps says nothing about maxzoom so must rely on layer options
    private createTileLayer(layer: Portal.MapLayerLeaf, layerName: string, getMapUrl: string, options: any) {
        let sourceOptions = <olx.source.TileWMSOptions>{
            url: getMapUrl,
            params: {
                'LAYERS': layerName,
                'TILED': true
            }
        };

        // maxZoom implemented for bing, mapquest, osm, stamen, tilejson, xyz only
        sourceOptions.maxZoom;

        var source = new ol.source.TileWMS(sourceOptions);

        // this functionality need to be injected into the map at the tile level
        {
            source.on("refresh", () => {
                var params = source.getParams();
                params["refresh-count"] = (params["refresh-count"] || 0) + 1;
                source.updateParams(params);
            });

            if (options["refresh-interval"]) {
                let interval = parseFloat(options["refresh-interval"]);
                if (typeof interval === "number") {
                    setInterval(() => source.dispatchEvent("refresh"), interval * 1000 * 60);
                }
            }
        }

        var tile = new ol.layer.Tile({
            visible: "false" !== options["visible"],
            title: layerName,
            id: `${layer.id}-${layerName}`,
            source: source
        });

        return tile;
    }

    private "wms-group"(options = this.options) {
        var d = $.Deferred<ol.layer.Group>();
        let layer = this.layer;

        geo.getCaps(layer).then(wms => {
            var layerNames = wms.Capability.Layer.Layer.map(l => l.Name);
            var getMapUrl = wms.Capability.Request.GetMap.DCPType[0].HTTP.Get.OnlineResource;

            // must match createTileLayer interpretation
            let childLayers = layerNames.map(layerName => Templates.asLayerTemplate({
                id: `${layer.id}-${layerName}`,
                text: layerName,
                url: getMapUrl
            }));

            // notify api of a change to this layer
            this.merge(childLayers);

            var layers = layerNames.map(layerName => this.createTileLayer(layer, layerName, getMapUrl, options));

            var groupOptions = <olx.layer.GroupOptions>{
                id: layer.id,
                title: layer.text,
                layers: layers,
                visible: "false" !== options["visible"]
            };

            // a min zoom has been specified, honor it
            if (layer.minlevel) {
                // TODO: minlevel should be a LOD level not a numeric value..then can specify scale, res or level
            }
            if (layer.maxlevel) {
                // TODO: should be a LOD level not a numeric value..then can specify scale, res or level
            }

            // TODO: levels should be a LOD level not a numeric value..then can specify scale, res or level
            Utils.ifOption(options, "min-resolution", v => {
                groupOptions.minResolution = parseFloat(v);
            });

            // TODO: levels should be a LOD level not a numeric value..then can specify scale, res or level
            Utils.ifOption(options, "max-resolution", v => {
                groupOptions.maxResolution = parseFloat(v);
            });

            Utils.ifOption(options, "visible", v => {
                groupOptions.visible = v !== "false";
            });

            var group = new ol.layer.Group(groupOptions);

            d.resolve(group);

        });

        return d;
    }

    private wms(options = this.options) {
        var d = $.Deferred<ol.layer.Tile>();

        geo.getCaps(this.layer).then(wms => {
            var layerNames = wms.Capability.Layer.Layer.map(l => l.Name);
            var getMapUrl = wms.Capability.Request.GetMap.DCPType[0].HTTP.Get.OnlineResource;
            var tile = this.createTileLayer(this.layer, layerNames.join(","), getMapUrl, options);
            d.resolve(tile);
        });

        return d;
    }


}

class Handler {

    static about = `
Uses _ol.source.TileWMS_ to manage the wms layer.  
    `;

    static options = {

        "layerType": {
            "about": "Identify the layer type",
            "domain": "wms|wms-group",
            "default": "wms",
        },

        "max-resolution": {
            "about": "Hide the layer beyond this resolution",
        },

        "min-resolution": {
            "about": "Minimum resolution before layer is visible",
        },

        "visible": {
            "about": "Hide the layer",
            "domain": "true|false",
            "default": "true"
        },
    }

    static create(args: { layer: Portal.MapLayerLeaf; view: MapView; mediator: Mediator }): ol.layer.Layer | JQueryDeferred<ol.layer.Layer> {
        var options = Utils.asDictionary(args.layer.Options.Values);
        let helper = new Helper(args.layer, args.view, args.mediator, options);
        return helper.create();
    }
}

export = Handler;